<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import fundraiserDonateMixin from '@/mixins/fundraiserDonateMixin.js'
import DonateAmountField from '@/components/donations/public/donate-amount-field.vue'
import TwCheckbox from '@/components/generic/forms/tw-checkbox.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwTextarea from '@/components/generic/forms/tw-textarea.vue'
import TwTransitionListContainer from '@/components/generic/tw-transition-list-container.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import FundraiserDonationAppFeeCard from '@/components/fundraisers/public/fundraiser-donation-app-fee-card.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import teamDonateMixin from '@/mixins/teamDonateMixin.js'
import { XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'TeamDonatePage',
  components: { TwTimeLeft, FundraiserDonationAppFeeCard, TwProgressBar, TwTransitionListContainer, TwTextarea, TwInput, TwValidationErrors, TwCheckbox, DonateAmountField, TwTransitionContainer, FontAwesomeIcon, TwButton, TwCard, TwContainer, XMarkIcon },
  mixins:[teamDonateMixin],
}
</script>

<template>
  <tw-transition-container>
    <div v-if="fundraiser" class="h-100 bg-cover bg-center bg-no-repeat" :style="`background-image: url('${fundraiser.cover_image_url}');`">
      <div class="bg-black/65">
        <div class="z-10 flex justify-center md:p-6">
          <tw-transition-list-container>
            <div class="w-full sm:max-w-lg">
              <tw-card v-if="fundraiser" class="rounded-none md:rounded-xl bg-white relative">
                <tw-button variant="link" class="absolute right-4 top-4" :to="{ name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug: fundraiser.slug} }">
                  <XMarkIcon class="size-7" />
                </tw-button>
                <div class="flex gap-3 flex-col text-center mt-8">
                  <h1 class="text-xl md:text-2xl">
                    {{ fundraiser.title }}
                    <br>
                    Team: {{ team.name }}
                  </h1>
                  <div> by <span>{{ fundraiser.cached.beneficiary_name }}</span> </div>
                  <div class="my-4">
                    <h5 v-if="fundraiser.cached.remaining > 0">
                      ${{ fundraiser.cached.remaining_formatted }} remaining to go
                    </h5>
                    <tw-progress-bar v-if="fundraiser.cached.percentage_raised && fundraiser.cached.percentage_raised > 0" class="mt-3 mb-2" :progress="fundraiser.cached.percentage_raised" />
                    <tw-time-left v-if="fundraiser.deadline" class="text-sm text-gray-600" :deadline="fundraiser.deadline" detailed />
                  </div>
                </div>
                <div v-if="!DonationCompleted">
                  <div>
                    <h5 class="text-center mt-5">
                      Amount to Give:
                    </h5>
                    <div v-if="!DonationGatewayActive && !DonationCompleted">
                      <donate-amount-field ref="donationField" v-model="DonationAmount" size="lg" />
                      <div v-if="fundraiser.cached.donation_highest_amount > 0" class="mt-5 text-center text-sm bg-gray-50 p-4 rounded-md">
                        A donation of <span class="text-blue-600 cursor-pointer" @click="DonationAmount = fundraiser.cached.donation_highest_amount + 1">${{ fundraiser.cached.donation_highest_amount }} or more</span> would make you the top giver so far.
                      </div>

                      <tw-input v-model="DonationName" required class="mt-4" label="Name:" placeholder="Enter your name" />
                      <tw-checkbox v-model="DonationAnonymousName" class="my-3">
                        Keep my name hidden from public view
                      </tw-checkbox>
                      <tw-checkbox v-model="DonationAnonymousAmount">
                        Keep my amount hidden from public view
                      </tw-checkbox>
                      <tw-textarea v-model="DonationComment" label="Leave a public message (optional)" class="w-full mt-8" placeholder="Message" />
                      <fundraiser-donation-app-fee-card :donation-amount="DonationAmount" v-model="DonationAppFeeAmount" class="mt-4" />
                      <div class="mt-10 grid grid-cols-2">
                        <h6>
                          Donation Total:
                        </h6>
                        <div class="text-right font-sans font-semibold">
                          ${{ donationTotalAmount }}
                        </div>
                      </div>
                      <div class="mt-4">
                        <tw-button block variant="primary" size="lg" :disabled="donateButtonDisabled" @click="startDonation">
                          Next Step
                        </tw-button>
                      </div>
                    </div>
                  </div>
                </div>
                <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
                <tw-transition-list-container>
                  <div v-if="DonationGatewayActive" id="checkout" />
                  <tw-container class="px-5">
                    <tw-button v-if="DonationGatewayActive" class="mt-2" size="lg" block variant="secondary" @click="cancelDonation">
                      Cancel
                    </tw-button>
                  </tw-container>
                </tw-transition-list-container>
                <div class="mt-4 text-xs text-center">
                  Your donation is safe and secure. All proceeds of your donation will go directly to <strong>{{ fundraiser.cached.beneficiary_name }}</strong>.
                </div>
              </tw-card>
            </div>
          </tw-transition-list-container>
        </div>
      </div>
    </div>
  </tw-transition-container>
</template>

<style scoped>

</style>
